/* eslint-disable no-dupe-keys */
import React, {useState, useEffect, useRef, SetStateAction, Dispatch} from 'react'
import desktopGreyIcon from '../../../../_metronic/assets/images/svg/data-room/desktop-grey-icon.svg'
import mobileWhiteIcon from '../../../../_metronic/assets/images/svg/data-room/mobile-white-icon.svg'
import chainLinkIcon from '../../../../_metronic/assets/images/svg/data-room/chain-link-grey-icon.svg'
import appleIcon from '../../../../_metronic/assets/images/svg/data-room/apple.svg'
import windowsIcon from '../../../../_metronic/assets/images/svg/data-room/windows.svg'
import androidIcon from '../../../../_metronic/assets/images/svg/data-room/android.svg'
import chevronIcon from '../../../../_metronic/assets/images/svg/data-room/chevron-top-grey.svg'
import {useIntl} from 'react-intl'
import {useParams} from 'react-router-dom'
import {useAuth} from '../../auth'
import {toast} from 'react-toastify'
import {getSingleContent} from '../core/_requests'
import {DateTime} from 'luxon'
import BarGraph from '../components/StatisticsWidgetBarDataRoom'
import NoDataPage from '../../widgets/components/NoDataPage'

interface TimespendData {
  totalTimeSpend: number
  updatedAt: string
}
interface DataItem {
  visitId: number
  deviceActiveStatus: string
  deviceType: string
  VisitorEmail: string
  details: string
  state: string
  updatedAt: string
  timespend: TimespendData
  createdAt: string
  ipAddress: string
  os: string
  country: string
  contentId: number
  city: string
  FileName: string
}

interface Column {
  icon: string
  label: string
}

const RowItem: React.FC<any> = ({
  deviceActiveStatus,
  deviceType,
  visitorEmail,
  updatedAt,
  timespend,
  os,
  country,
  city,
  fileName,
}) => {
  const [open, setOpen] = useState(false)
  const toggleRow = () => {
    setOpen(!open)
  }
  const {formatMessage} = useIntl()

  let classes = open ? 'open' : ''

  function formatTime(seconds: number) {
    if (seconds >= 3600) {
      const hours = Math.floor(seconds / 3600)
      const remainingSeconds = seconds % 3600
      const minutes = Math.floor(remainingSeconds / 60)
      const finalSeconds = remainingSeconds % 60
      return `${hours}hr ${minutes}min ${finalSeconds}s`
    } else if (seconds >= 60) {
      const minutes = Math.floor(seconds / 60)
      const finalSeconds = seconds % 60
      return `${minutes}min ${finalSeconds}s`
    } else {
      return `${seconds}s`
    }
  }

  function getTimeDifference(date: any) {
    const minutes = Math.abs(
      Math.floor(
        date &&
          DateTime.utc().diff(DateTime.fromISO(date), ['days', 'hours', 'minutes']).toObject()
            .minutes
      )
    )

    const days = Math.abs(
      Math.floor(
        date &&
          DateTime.utc().diff(DateTime.fromISO(date), ['days', 'hours', 'minutes']).toObject().days
      )
    )

    const hours = Math.abs(
      Math.floor(
        date &&
          DateTime.utc().diff(DateTime.fromISO(date), ['days', 'hours', 'minutes']).toObject().hours
      )
    )
    if (days === 0 && hours === 0) {
      return `${minutes} ${formatMessage({id: 'min ago'})}`
    }
    if (days === 0) {
      return `${hours} ${formatMessage({id: 'hrs ago'})}`
    } else if (days === 7) {
      return `${formatMessage({id: '1 week'})}`
    } else if (days < 7) {
      return `${days} ${formatMessage({id: 'days ago'})}`
    } else if (days > 7) {
      return `${days} ${formatMessage({id: 'days ago'})}`
    } else {
      return DateTime.fromISO(date).toFormat('MMM dd')
    }
  }

  return (
    <li className={classes}>
      <div className='heading'>
        <div className='col font-size-13 font-weight-400 text-truncate'>
          <div
            className='visitor-active-status me-2 d-flex flex-row align-items-center justify-content-center '
            style={{backgroundColor: deviceActiveStatus}}
          >
            <div className='d-flex'>
              {deviceType === 'WEB' ? (
                <>
                  <img src={desktopGreyIcon} alt={formatMessage({id: 'Desktop'})} />
                  {os === 'ANDROID' && (
                    <img
                      className='ms-2 mt-2'
                      src={androidIcon}
                      alt={formatMessage({id: 'Android'})}
                    />
                  )}
                  {os === 'WINDOWS' && (
                    <img
                      className='ms-3 mt-2'
                      src={windowsIcon}
                      alt={formatMessage({id: 'Windows'})}
                    />
                  )}
                  {os === 'APPLE' && (
                    <img className='ms-2 ' src={appleIcon} alt={formatMessage({id: 'Apple'})} />
                  )}
                </>
              ) : (
                <>
                  <img src={mobileWhiteIcon} alt={formatMessage({id: 'Mobile'})} />
                  {os === 'ANDROID' && (
                    <img
                      className='me-2 mt-2'
                      src={androidIcon}
                      alt={formatMessage({id: 'Android'})}
                    />
                  )}
                  {os === 'WINDOWS' && (
                    <img
                      className='me-3 mt-2'
                      src={windowsIcon}
                      alt={formatMessage({id: 'Windows'})}
                    />
                  )}
                  {os === 'APPLE' && (
                    <img className='me-3' src={appleIcon} alt={formatMessage({id: 'Apple'})} />
                  )}
                </>
              )}
            </div>
          </div>{' '}
          <p className='ms-2 m-0 dark_text_color'>{visitorEmail || '-'}</p>
        </div>
        <div className='col font-size-13 font-weight-400 mb-5'>
          <img src={chainLinkIcon} alt='' className='me-2 '></img>
          <p className='m-0 dark_text_color'>{fileName ? fileName : '-'}</p>
        </div>
        <div className='col font-size-13 font-weight-400 dark_text_color'>
          {getTimeDifference(updatedAt)}
        </div>
        <div className='col font-size-13 font-weight-400'>
          <p className='m-0 dark_text_color'>
            {timespend?.totalTimeSpend ? formatTime(timespend?.totalTimeSpend) : '-'}
          </p>
        </div>
        <div className='col'>
          <div
            className='visitor-action-button d-flex flex-row align-items-center justify-content-center'
            onClick={toggleRow}
          >
            <img
              src={chevronIcon}
              alt=''
              style={{transform: `rotate(${open ? '0deg' : '180deg'})`}}
            ></img>
          </div>
        </div>
      </div>
      <RowContent
        open={open}
        deviceType={deviceType}
        os={os}
        city={city}
        country={country}
        timeSpend={timespend}
      />
    </li>
  )
}

interface RowContentProps {
  open: boolean
  deviceType: string
  os: string
  country: string
  city: string
  timeSpend: any
}

const RowContent: React.FC<RowContentProps> = ({
  open,
  deviceType,
  os,
  city,
  country,
  timeSpend,
}) => {
  const {formatMessage} = useIntl()
  let jsxhtml = <div className='content'></div>

  if (open && timeSpend) {
    jsxhtml = (
      <div className='content open'>
        <div className='visitors-details-wrapper'>
          <span className='visitors-detail-head font-size-12 font-weight-600 dark_text_color'>
            {formatMessage({id: 'Device, OS & Location Info'})}
          </span>
          <div className='visitors-detail-head-info  d-flex flex-row align-items-center '>
            <span className='me-2 dark_text_color'>
              {deviceType === 'WEB' ? (
                <img src={desktopGreyIcon} alt={formatMessage({id: 'Desktop'})} />
              ) : (
                <img src={mobileWhiteIcon} alt={formatMessage({id: 'Mobile'})} />
              )}
            </span>
            <div className=''>
              {os === 'ANDROID' && (
                <img className='me-2' src={androidIcon} alt={formatMessage({id: 'Android'})} />
              )}
              {os === 'WINDOWS' && (
                <img className='mt-3' src={windowsIcon} alt={formatMessage({id: 'Windows'})} />
              )}
              {os === 'APPLE' && (
                <img className='' src={appleIcon} alt={formatMessage({id: 'Apple'})} />
              )}
            </div>
            <span className='visitors-location font-size-13 font-weight-400 dark_text_color'>
              {city + ' ,' + country}
            </span>
          </div>
          <h6 className='font-size-16 font-weight-600 dark_text_color'>
            {formatMessage({id: 'Total Time spend on document'})}
          </h6>
          <BarGraph pageData={timeSpend.totalTimeSpend} />
        </div>
      </div>
    )
  }

  return <div>{jsxhtml}</div>
}

interface TableProps {
  data: DataItem[]
  columns: Column[]
  fileName: string
  showAllVisits: boolean
  setShowAllVisits: Dispatch<SetStateAction<boolean>>
}

const Table: React.FC<TableProps> = ({data, columns, fileName, showAllVisits}) => {
  const [headerFixed, setHeaderFixed] = useState(false)
  const headerRef = useRef<HTMLDivElement>(null)
  const visibleData = showAllVisits ? data : data?.slice(0, 5)
  const file = fileName?.includes('/') ? fileName?.split('/').pop() : fileName
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY
      const headerOffset = headerRef.current?.getBoundingClientRect().top ?? 0

      if (scrollTop >= headerOffset) {
        setHeaderFixed(true)
      } else {
        setHeaderFixed(false)
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const headerClasses = headerFixed ? 'header fixed' : 'header'

  const columnsJSX = columns.map((item, index) => <HeaderColumn key={index} label={item.label} />)

  const rowsJSX = visibleData?.map((item) => (
    <RowItem key={item.visitId} fileName={file} {...item} />
  ))

  return (
    <div className='table'>
      <div className={headerClasses} ref={headerRef}>
        {columnsJSX}
      </div>
      <ul>{rowsJSX}</ul>
    </div>
  )
}

interface HeaderColumnProps {
  label: string
}

const HeaderColumn: React.FC<HeaderColumnProps> = ({label}) => {
  return <div className='hcol font-size-12 font-weight-600'>{label}</div>
}
const MainFileActivityView = () => {
  const {contentId} = useParams()
  const [, setSingleContentLoading] = useState(false)
  const [singleContentData, setSingleContentData] = useState<any>()
  const {companyId} = useAuth()
  const {formatMessage} = useIntl()
  const [showAllVisits, setShowAllVisits] = useState<boolean>(false)

  const getSingleContentById = async () => {
    try {
      setSingleContentLoading(true)
      if (companyId && contentId) {
        const {
          data: {data, success, errors},
        } = await getSingleContent(companyId, contentId)
        if (success) {
          setSingleContentData(data)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setSingleContentLoading(false)
    }
  }

  useEffect(() => {
    getSingleContentById()
  }, [companyId, contentId]) // eslint-disable-line react-hooks/exhaustive-deps

  const cols: Column[] = [
    {
      icon: '',
      label: formatMessage({id: 'Visitor Email'}),
    },
    {
      icon: '',
      label: formatMessage({id: 'Document details'}),
    },
    {
      icon: '',
      label: formatMessage({id: 'Last active'}),
    },
    {
      icon: '',
      label: formatMessage({id: 'Time spent'}),
    },
    // {
    //   icon: '',
    //   label: 'Viewed',
    // },
    {
      icon: '',
      label: formatMessage({id: 'Actions'}),
    },
  ]

  return (
    <div className='file-activity-wrapper bg-white border border-muted p-6 rounded-2 mt-4'>

      <div className='d-flex justify-content-between mb-4'>

        <h5 className='font-size-16 lh-base text-dark'>
          {formatMessage({id: 'All Visits'})}
        </h5>

        {singleContentData?.visitsData?.length > 5 && (
          <div className='recent-visits-header-right d-flex flex-end'>
            {!showAllVisits ? (
              <p
                className='m-0 text-primary font-size-14 lh-base cursor-pointer'
                onClick={() => setShowAllVisits(true)}
              >
                {formatMessage({id: 'View All'})}
              </p>
            ) : null}
          </div>
        )}
      </div>

      <div className='table-responsive'>
        {singleContentData?.visitsData && singleContentData.visitsData.length > 0 ? (
          <Table
            data={singleContentData?.visitsData}
            columns={cols}
            fileName={singleContentData?.content?.name}
            showAllVisits={showAllVisits}
            setShowAllVisits={setShowAllVisits}
          />
        ) : (
          <div className='no-data-table'>
            <NoDataPage mainfileActivity={true} />
          </div>
        )}
      </div>
    </div>
  )
}

export default MainFileActivityView
